import { Divider } from '@mantine/core'
import {
  Alert,
  Box,
  Button,
  ButtonText,
  Flex,
  Modal,
  Typography,
} from '@percent/lemonade'

import type { OpportunityFormAutomaticTimeTrackingConfirmationModalProps } from './opportunity-form-automatic-time-tracking-confirmation-modal.types'

export function OpportunityFormAutomaticTimeTrackingConfirmationModal({
  isOpen,
  closeModal,
  handleIgnore,
  handleFix,

  title,
  alertTitle,
  alertDescription,
  cancelBtnLabel,
  ignoreBtnLabel,
  fixBtnLabel,
}: Readonly<OpportunityFormAutomaticTimeTrackingConfirmationModalProps>) {
  return (
    <Modal borderRadiiSize="xlarge" onClose={closeModal} open={isOpen}>
      <Box style={{ padding: '1rem 1.5rem 1.5rem 1.5rem' }}>
        <Typography
          style={{
            fontSize: '1.25rem',
            lineHeight: '1.875rem',
            fontWeight: '600',
          }}
        >
          {title}
        </Typography>
        <Divider my={16} />
        <Alert variant="info" title={alertTitle}>
          <Typography $color="gray600">{alertDescription}</Typography>
        </Alert>
        <Flex mt="2rem" gap="1rem" justify="space-between" align="center">
          <ButtonText onClick={closeModal}>{cancelBtnLabel}</ButtonText>
          <Flex gap="1rem">
            <Button
              variant="secondary"
              onClick={() => {
                handleIgnore()
              }}
            >
              {ignoreBtnLabel}
            </Button>
            <Button variant="primary" onClick={handleFix}>
              {fixBtnLabel}
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Modal>
  )
}
